import { LoadingSpinner } from './LoadingSpinner'

type LoadingScreenProps = {
  message?: string
  fullHeight?: boolean
  className?: string
}

export function LoadingScreen({
  message = '読み込み中…',
  fullHeight = true,
  className = '',
}: LoadingScreenProps) {
  return (
    <div
      className={[
        'loading-screen',
        fullHeight ? 'loading-screen--full' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <LoadingSpinner size="lg" label={message} />
    </div>
  )
}
